import script from "./TestimonialsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsPage.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsPage.vue?vue&type=style&index=0&id=111352f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111352f3"]])

export default __exports__